import React, { useEffect, memo } from "react";
import { useHistory } from "react-router-dom";

import { ROUTE_SEARCH } from "../../../routes";

import useFilter from "../../../hooks/useFilter";
import { calculatePageSize } from "../../../libs/pagingDetail";

import SingleSimCardComponent from "../singleSimCard";
import PaginationComponent from "../pagination";

import { SimsRow } from "../sims/styledSims";

import { AllResultWrapper } from "./styledSearch";

const ShowAllResult = ({
  data,
  count,
  filter,
  searchRun,
  queryParams,
  filterCategoriesRun,
}) => {
  const history = useHistory();
  const { onChange, filterState } = useFilter();

  const handleChangePage = (event, value) => {
    onChange("page", value);
    window.scroll({
      top: 200,
      left: 0,
      behavior: "smooth",
    });
  };

  const onHistoryChange = (search) => {
    const searchparams = new URLSearchParams(search);
    const queryParams = searchparams.get("q");
    const pageParams = Number(searchparams.get("page"));
    if (filter.isFilter) {
      filterCategoriesRun(undefined, {
        q: queryParams,
        type: filter.filterType,
        page_size: 12,
        page: pageParams && pageParams,
      });
    } else {
      searchRun({
        q: queryParams,
        offset: pageParams && (pageParams - 1) * 12,
        limit: 12,
      });
    }
  };

  useEffect(() => {
    history.listen((obj) => {
      if (
        (obj.pathname == ROUTE_SEARCH || obj.pathname == `${ROUTE_SEARCH}/`) &&
        obj.search.includes("page")
      ) {
        onHistoryChange(obj.search);
      } else {
        return;
      }
    });
  }, []);

  return (
    <AllResultWrapper className="p-3 d-flex flex-column align-items-center">
      <div className="mb-3">
        <span>
          نتایج جستجو برای"
          <span className="blue-detail">
            <span className="blue-detail">&nbsp;{queryParams}</span>
          </span>
          "
        </span>
        {filter.isFilter && (
          <span>
            &nbsp;در دسته‌ی
            <span className="blue-detail">&nbsp;{filter.filterName}</span>
          </span>
        )}
      </div>
      <span className="mb-5">{count}&nbsp;آزمایش</span>
      <SimsRow>
        {data?.map((product) => {
          return <SingleSimCardComponent data={product} key={product.id} className="my-2" />;
        })}
      </SimsRow>
      <PaginationComponent
        pageNumber={calculatePageSize(count)}
        currentPage={filterState["page"] || 1}
        handleChangePage={handleChangePage}
        className="mt-5"
        defaulPage={1}
      />
    </AllResultWrapper>
  );
};

export default memo(ShowAllResult);
